import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.black.main,
  },
  attachmentButton: {
    textTransform: 'uppercase',
    height: 40,
    [theme.breakpoints.down(430)]: {
      width: '100%',
    },
  },

  label: {
    color: theme.palette.gray.efesGray,
    display: 'flex',
    '& p': {
      color: theme.palette.success.main,
    },
  },
  dropZoneContainer: {
    backgroundColor: theme.palette.white.efesBackgroundLight,
    border: `1px solid ${theme.palette.gray.formSectionBorder}`,
    borderRadius: 10,
    padding: '10px 18px 12px',
  },
}));

export default useStyles;
